import { verticalTypesToPamGVIDEnum } from '../../enums/vertical-types.enum';

export const appMiddleware = ({ getState, dispatch }) => (next) => (action) => {
    // Execute the reducer.
    const result = next(action);

    // AFTER reducer execution section.
    const stateAfter = getState();

    const actionsAfter = {
        'app/setCurrentVertical': () => dispatchFillGVID(dispatch, stateAfter, action.payload),
        'app/fillPamGameVerticalID': () => setPamGVID(action.payload),
    };

    // Execute AFTER actions.
    actionsAfter[action.type]?.();

    // Finish the middleware.
    return result;
};

function dispatchFillGVID (dispatch, state, currentVerticalId) {
    const verticalsById = state?.app?.verticalsById || {};
    const pamGVID = verticalTypesToPamGVIDEnum[verticalsById?.[currentVerticalId]?.type];
    if (pamGVID) {
        dispatch({ type: 'app/fillPamGameVerticalID', payload: pamGVID });
    }
}

function setPamGVID (pamGVID) {
    if (pamGVID && AsgFW) {
        AsgFW.setDefaultGameVerticalID(pamGVID);
    }
}

